document.addEventListener('DOMContentLoaded', () => {

  const carouselStates = new Map();

  window.reinitCarousel = (carousel) => {
    initCarousel(carousel);
  };

  const initCarousel = (carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const viewport = carousel.querySelector('.custom-carousel__viewport');

    const range = carousel.dataset.activeRange || "1";

    const activeRange = carousel.querySelector(
      `.carousel-data .carousel-range[data-range="${range}"]`
    );

    if (!activeRange) return;

    const slides = [...activeRange.querySelectorAll('.custom-carousel__slide')];
    if (!slides.length) return;

    // CLEAN TRACK
    track.innerHTML = '';

    slides.forEach(slide => {
      track.appendChild(slide.cloneNode(true));
    });

    // RESET STATE COMPLETELY
    let state = carouselStates.get(carousel);

    if (state?.cleanup) {
      state.cleanup();
    }

    state = {
      index: 0,
      slideCount: slides.length
    };

    carouselStates.set(carousel, state);

    const setTransform = () => {
      const w = viewport.getBoundingClientRect().width;
      track.style.transform = `translate3d(-${w * state.index}px,0,0)`;
    };

    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    const handlePrev = () => {
      state.index = (state.index - 1 + state.slideCount) % state.slideCount;
      setTransform();
    };

    const handleNext = () => {
      state.index = (state.index + 1) % state.slideCount;
      setTransform();
    };

    prevBtn?.addEventListener('click', handlePrev);
    nextBtn?.addEventListener('click', handleNext);

    state.cleanup = () => {
      prevBtn?.removeEventListener('click', handlePrev);
      nextBtn?.removeEventListener('click', handleNext);
    };

    setTransform();
  };


  const variantIdToRange = {
    '50761509667117': "1",
    '50761509765421': "2",
    '50761509863725': "3"
  };

  const colorToRange = {
    'Black': "1",
    'Gradient': "2",
    'Tortoise': "3"
  };

  // Get current variant ID from product form
  const getCurrentVariantId = () => {
    // Try product form first (main product page)
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const input = productForm.querySelector('[name="id"]');
      if (input) return input.value;
    }

    // Try URL parameter as fallback
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) return variantId;

    // Try checked radio inputs
    const checkedRadio = document.querySelector('input[name="id"]:checked');
    if (checkedRadio) return checkedRadio.value;

    return null;
  };

  // Get current color from selected variant
  const getCurrentColor = () => {
    // Try checked color radio buttons
    const colorInputs = document.querySelectorAll('input[name*="olor"], input[name*="olor"]');
    for (const input of colorInputs) {
      if (input.checked) {
        return input.value;
      }
    }

    // Try URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId && variantIdToRange[variantId]) {
      // Map variant to color
      const range = variantIdToRange[variantId];
      const rangeToColor = { '1': 'Black', '2': 'Gradient', '3': 'Tortoise' };
      return rangeToColor[range] || null;
    }

    return null;
  };

  const switchCarouselByVariant = (variantId) => {
    if (!variantId) {
      console.warn('[CAROUSEL] No variantId provided');
      return;
    }

    const target = variantIdToRange[String(variantId)];
    if (!target) {
      console.warn('[CAROUSEL] No range mapping for variant:', variantId);
      return;
    }

    document.querySelectorAll('[data-carousel]').forEach(carousel => {
      carousel.dataset.activeRange = target;
      initCarousel(carousel);
    });
  };

  const switchCarousel = (color) => {
    if (!color) {
      console.warn('[CAROUSEL] No color provided');
      return;
    }

    const target = colorToRange[color];
    if (!target) {
      console.warn('[CAROUSEL] No range mapping for color:', color);
      return;
    }

    document.querySelectorAll('[data-carousel]').forEach(carousel => {
      carousel.dataset.activeRange = target;
      initCarousel(carousel);
    });
  };

  // Subscribe to option-value-selection-change (fired by global.js VariantSelects)
  if (typeof subscribe !== 'undefined') {
    subscribe('option-value-selection-change', ({ data }) => {
      const { selectedOptionValues } = data || {};
      if (!selectedOptionValues) return;

      // Find the color option value
      const colorValue = Object.values(selectedOptionValues).find((_, key) =>
        key.toLowerCase().includes('color') || key.toLowerCase().includes('olor')
      );

      if (colorValue) {
        switchCarousel(colorValue);
      }
    });
  }

  // Subscribe to variant-change (fired by product-info.js)
  if (typeof subscribe !== 'undefined') {
    subscribe('variant-change', ({ data }) => {
      const { html, sectionId } = data || {};
      if (!html) return;

      // Try to get variant from HTML response
      const variantData = html.querySelector('[data-selected-variant]');
      if (variantData) {
        try {
          const variant = JSON.parse(variantData.textContent);
          if (variant) {
            // Try by color first
            const color = variant.option1 || variant.option2 || variant.option3;
            if (color) {
              switchCarousel(color);
            }
            // Also try by variant ID
            switchCarouselByVariant(variant.id);
          }
        } catch (e) {
          console.warn('[CAROUSEL] Failed to parse variant data');
        }
      }
    });
  }

  // Listen to radio input changes directly (fallback)
  document.querySelectorAll('input[type="radio"]').forEach(el => {
    el.addEventListener('change', () => {
      const color = getCurrentColor();
      if (color) {
        switchCarousel(color);
      }
    });
  });

  // INIT on page load
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const variantId = getCurrentVariantId();
    const color = getCurrentColor();

    let range = "1";
    if (color && colorToRange[color]) {
      range = colorToRange[color];
    } else if (variantId && variantIdToRange[variantId]) {
      range = variantIdToRange[variantId];
    }

    carousel.dataset.activeRange = range;
    initCarousel(carousel);
  });

});
